import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    title: 'Why Choose 24AI Cooking?',
    subtitle: 'Powered by advanced AI technology to transform your cooking experience',
    aiPowered: {
      title: 'AI-Powered Recipes',
      description: 'Get intelligent recipe recommendations based on your available ingredients'
    },
    instantResults: {
      title: 'Instant Results',
      description: 'Receive personalized recipes in seconds, not hours'
    },
    dietaryNeeds: {
      title: 'Dietary Preferences',
      description: 'Allergies, preferences, and dietary restrictions are all taken into account'
    },
    creativeCooking: {
      title: 'Creative Cooking',
      description: 'Discover new flavor combinations you never imagined'
    },
    timeSaving: {
      title: 'Time Saving',
      description: 'No more endless recipe searching - your perfect meal is just a photo away'
    },
    easyToUse: {
      title: 'Easy to Use',
      description: 'Simply point, shoot, and get cooking with our intuitive interface'
    }
  },
  ar: {
    title: 'لماذا تختار 24AI Cooking؟',
    subtitle: 'مدعوم بتقنية الذكاء الاصطناعي المتطورة لتحويل تجربة الطبخ الخاصة بك',
    aiPowered: {
      title: 'وصفات مدعومة بالذكاء الاصطناعي',
      description: 'احصل على توصيات وصفات ذكية بناءً على المكونات المتاحة لديك'
    },
    instantResults: {
      title: 'نتائج فورية',
      description: 'احصل على وصفات مخصصة في ثوانٍ، وليس ساعات'
    },
    dietaryNeeds: {
      title: 'التفضيلات الغذائية',
      description: 'يتم أخذ الحساسيات والتفضيلات والقيود الغذائية جميعاً في الاعتبار'
    },
    creativeCooking: {
      title: 'طبخ إبداعي',
      description: 'اكتشف تركيبات نكهات جديدة لم تتخيلها من قبل'
    },
    timeSaving: {
      title: 'توفير الوقت',
      description: 'لا مزيد من البحث المستمر عن الوصفات - وجبتك المثالية على بعد صورة واحدة فقط'
    },
    easyToUse: {
      title: 'سهل الاستخدام',
      description: 'ما عليك سوى التوجيه والتصوير والبدء في الطبخ باستخدام واجهتنا البديهية'
    }
  }
};

const Features = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const features = [
    {
      icon: '🤖',
      title: t.aiPowered.title,
      description: t.aiPowered.description
    },
    {
      icon: '⚡',
      title: t.instantResults.title,
      description: t.instantResults.description
    },
    {
      icon: '🥗',
      title: t.dietaryNeeds.title,
      description: t.dietaryNeeds.description
    },
    {
      icon: '✨',
      title: t.creativeCooking.title,
      description: t.creativeCooking.description
    },
    {
      icon: '⏱️',
      title: t.timeSaving.title,
      description: t.timeSaving.description
    },
    {
      icon: '📱',
      title: t.easyToUse.title,
      description: t.easyToUse.description
    }
  ];

  return (
    <section id="features" className="py-20 px-4 bg-gray-50" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t.title}
          </h2>
          <p className="text-xl text-gray-600">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
              <div className="text-5xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-dark mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="/start"
            className="inline-block px-8 py-4 bg-gradient-green text-white rounded-lg text-lg font-semibold hover:opacity-90 transition shadow-lg"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {language === 'en' ? 'Start Your Journey →' : 'ابدأ رحلتك ←'}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features;



